import { FirmAccounts } from "./FirmAccounts";
import { WalletSummary } from "./WalletSummary";
import type { CustomerRole, WalletSummary as Wallet } from "../types/api";

export function LawFirmAccountCenter({
  wallet,
  role,
  onHome,
  onQuotaChanged,
}: {
  wallet: Wallet;
  role: CustomerRole;
  onHome: () => void;
  onQuotaChanged?: () => void;
}) {
  return (
    <div className="law-portal-page">
      <nav className="law-portal-nav">
        <button type="button" onClick={onHome}>≪ 返回查询页</button>
      </nav>
      <main className="law-portal-main">
        <WalletSummary wallet={wallet} />
        <FirmAccounts role={role} onQuotaChanged={onQuotaChanged} unallocatedBalance={wallet.unallocated_balance} />
      </main>
    </div>
  );
}
